import React from 'react'

import UnknownSaleInfo from './UnknownSaleInfo'

import PromocodeSaleInfo from './PromocodeSaleInfo'
import LoyaltyBonusSystemSaleInfo from './LoyaltyBonusSystemSaleInfo'

import {
  ORDER_SALE_TYPE_PROMOCODE,
  ORDER_SALE_TYPE_LOYMAX
} from '@@partner:config/order-sale-types'
import { CustomerPromocodes } from '@@partner:types:app'

export interface CustomerSaleInfoProps {
  orderSale: CustomerPromocodes
}

const SaleComponents = {
  [ORDER_SALE_TYPE_LOYMAX]: LoyaltyBonusSystemSaleInfo,
  [ORDER_SALE_TYPE_PROMOCODE]: PromocodeSaleInfo
}

export default function CustomerSaleInfo ({ orderSale }: CustomerSaleInfoProps) {
  const SaleComponent = SaleComponents[orderSale.type]

  if (SaleComponent) {
    return <SaleComponent saleInfo={orderSale} />
  }

  return <></>

}
